/*
 * rebuy-cart-redirect-fix.js
 * Holistic Goddess - Purity theme + Rebuy Smart Cart
 *
 * Problem
 * -------
 * The theme's add-to-cart handler (module-add-to-cart.js) adds via AJAX, then tries to
 * open the theme's native <cart-drawer>. Rebuy Smart Cart is the cart, so <cart-drawer>
 * isn't on the page; the theme hits its fallback branch:
 *     this.cart = querySelector('cart-drawer') || querySelector('main-cart'); // null
 *     if (!this.cart ...) { window.location = routes.cart_url }   // <- redirect to /cart
 * So every Add to Cart (subscription OR one-time) redirects to the cart page.
 *
 * Fix
 * ---
 * Intercept the product form submit in the capture phase (runs before the theme's own
 * submit handler), add the item ourselves via /cart/add.js (so selling_plan, quantity
 * and variant id are preserved), and stop the theme's handler from running - which
 * prevents its redirect. Rebuy Smart Cart then opens (it intercepts /cart/add and opens
 * itself; we also nudge it and refresh the theme's header count as a fallback).
 *
 * Safe by design: it only takes over when the theme's own cart drawer is NOT present,
 * and it ignores forms inside the Rebuy cart. If Rebuy is ever removed and the native
 * drawer returns, this does nothing and the theme behaves normally.
 *
 * Load this site-wide (see install note). It is not specific to the subscription widget;
 * the redirect affects every product.
 */
(function () {
  'use strict';

  window.__hgCartRedirectFixVersion = '1';

  function isCartAddForm(form) {
    return form instanceof HTMLFormElement &&
      /\/cart\/add/.test(form.getAttribute('action') || '');
  }

  function insideRebuy(el) {
    return !!(el.closest && el.closest('[id*="rebuy" i], .rebuy-cart, [data-rebuy-cart]'));
  }

  function themeCartDrawerExists() {
    return !!(document.querySelector('cart-drawer') || document.querySelector('main-cart'));
  }

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function onSubmit(event) {
    var form = event.target;
    if (!isCartAddForm(form)) return;
    if (insideRebuy(form)) return;          // Rebuy's own cart forms behave normally
    if (themeCartDrawerExists()) return;    // theme can open its own drawer; stay out of the way

    // Take over before the theme's handler runs, so its /cart redirect never fires.
    event.preventDefault();
    event.stopImmediatePropagation();

    // The theme renders [name=id] disabled and re-enables it in its own JS; ensure it's on.
    var idInput = form.querySelector('[name="id"]');
    if (idInput && idInput.disabled) idInput.disabled = false;

    var button = form.querySelector('[type="submit"], [name="add"]');
    setLoading(button, true);

    fetch(shopRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (!res.ok || (res.data && res.data.status)) {
          showError(form, res.data && (res.data.description || res.data.message));
          return;
        }
        refreshThemeHeader(res.data);
        openRebuy();
      })
      .catch(function (e) {
        console.error('[hg-cart-fix]', e);
        showError(form, null);
      })
      .finally(function () { setLoading(button, false); });
  }

  function setLoading(button, on) {
    if (!button) return;
    if (on) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
    } else {
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
    }
  }

  /* Keep the theme's header cart count/UI in sync without opening the theme drawer. */
  function refreshThemeHeader(addResponse) {
    try {
      if (window.NextSkyTheme && NextSkyTheme.publish && NextSkyTheme.PUB_SUB_EVENTS) {
        NextSkyTheme.publish(NextSkyTheme.PUB_SUB_EVENTS.cartUpdate, {
          source: 'hg-cart-redirect-fix',
          cartData: addResponse
        });
      }
    } catch (e) { /* non-fatal */ }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
  }

  /* Rebuy usually auto-opens when it sees a /cart/add; these are belt-and-suspenders. */
  function openRebuy() {
    try {
      var rb = window.Rebuy;
      if (rb) {
        var sc = rb.SmartCart || rb.smartCart;
        if (sc && typeof sc.show === 'function') { sc.show(); return; }
        if (sc && typeof sc.open === 'function') { sc.open(); return; }
        if (typeof rb.open === 'function') { rb.open(); return; }
      }
    } catch (e) { /* fall through to events */ }
    document.dispatchEvent(new CustomEvent('rebuy:cart.show', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('rebuy:smartcart:show', { bubbles: true }));
  }

  function showError(form, message) {
    var scope = form.closest('product-form, .product-form, [data-section-id]') || form;
    var wrap = scope.querySelector('.product-form__error-message-wrapper');
    if (wrap) {
      var span = wrap.querySelector('.product-form__error-message');
      if (span) span.textContent = message || 'Could not add to cart. Please try again.';
      wrap.hidden = false;
      return;
    }
    try {
      if (window.notifier && notifier.show) {
        notifier.show(message || 'Could not add to cart. Please try again.', 'error', 4000);
        return;
      }
    } catch (e) { /* ignore */ }
    if (message) console.warn('[hg-cart-fix]', message);
  }

  /* Capture phase => runs before the theme's form submit handler. */
  document.addEventListener('submit', onSubmit, true);
})();